<template>
	<div
		class="in-app-help"
		:class="{
			'left-side': isFlowBuilder,
			'nudge-top': isGuidedTutorialOn,
			'builder-task-log-mode': isTaskLogOpen,
			'builder-version-history-mode': isVersionHistoryOpen,
		}"
	>
		<div class="in-app-help-button" @click="toggleIsOpenHelpMenu">
			<InAppIcon :isOpen="isOpen" />
		</div>
		<InAppHelpMenu class="help-menu-container" :isOpen="isOpen" :isOnLeft="isFlowBuilder" @setIsOpen="setIsOpen" />
	</div>
</template>

<script>
import InAppIcon from './InAppIcon';
import InAppHelpMenu from './InAppHelpMenu';
import IntercomService from '@/utils/IntercomService';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { useIsTaskLogOpen } from '@/store/modules/analytics/getters.js';
import { useSelectedWorkflowVersionId } from '@/store/modules/workflows/modules/versions/getters.js';

export default {
	name: 'InAppHelp',
	components: { InAppIcon, InAppHelpMenu },
	props: {
		isGuidedTutorialOn: { type: Boolean },
		isFlowBuilder: { type: Boolean },
	},
	computed: {
		...mapGettersShorthand({ useIsTaskLogOpen, useSelectedWorkflowVersionId }),
		isVersionHistoryOpen() {
			return !!this.useSelectedWorkflowVersionId;
		},
		isTaskLogOpen() {
			return this.useIsTaskLogOpen(this.$route);
		},
	},
	methods: {
		toggleIsOpenHelpMenu() {
			this.isOpen = !this.isOpen;
			this.setIntercomAlignment();
		},
		setIntercomAlignment() {
			IntercomService.update({ alignment: this.isFlowBuilder ? 'left' : 'right' });
			IntercomService.update({ vertical_padding: 0, horizontal_padding: 0 });
		},
		setIsOpen(isOpen) {
			this.isOpen = isOpen;
		},
	},
	created() {
		this.setIntercomAlignment(); // e.g. when re-mounts on move to FlowBuilder
		IntercomService.onHide(this.toggleIsOpenHelpMenu);
	},
	data() {
		return { isOpen: false };
	},
};
</script>

<style lang="scss" scoped>
.in-app-help {
	$button-bottom: 18px;

	.in-app-help-button,
	.help-menu-container {
		position: fixed;
		z-index: $z-index-in-app-help;
	}
	.in-app-help-button {
		bottom: $button-bottom;
	}
	.help-menu-container {
		bottom: $vertical-menu-margin;
	}
	&.left-side {
		&.builder-version-history-mode {
			.in-app-help-button,
			.help-menu-container {
				left: calc(#{$horizontal-menu-margin} + #{$builder-version-history-width});
			}
		}
		&.builder-task-log-mode {
			.in-app-help-button,
			.help-menu-container {
				left: calc(#{$horizontal-menu-margin} + #{$builder-task-log-width});
			}
		}
		&:not(.builder-version-history-mode, .builder-task-log-mode) {
			.in-app-help-button,
			.help-menu-container {
				left: $horizontal-menu-margin;
			}
		}
	}

	&:not(.left-side) {
		.in-app-help-button {
			right: $horizontal-menu-margin;
		}
		.help-menu-container {
			right: $horizontal-menu-margin;
		}
	}

	&.nudge-top {
		$top: 55px;
		.in-app-help-button {
			bottom: calc(#{$top} + #{$button-bottom});
		}
		.help-menu-container {
			bottom: calc(#{$top} + #{$vertical-menu-margin});
		}
	}
}
</style>

<style lang="scss">
.intercom-messenger-frame {
	bottom: $vertical-menu-margin !important;

	iframe {
		border-radius: 15px;
		overflow: hidden;
	}
}
</style>
